module.exports = __webpack_public_path__ + "img/logo-theme.cc086ba8.svg";